<script setup lang="ts">

import TheBottomSheet from '@/components/TheBottomSheet.vue'
import CoinIcon from '@/components/icons/CoinIcon.vue'
import { T } from '@tolgee/vue'
import { numberToStringFormat } from '@/helpers/utils'

defineProps<{
  show: boolean,
}>()

defineEmits<{
  (e: 'hide'): void
}>()

const formattingTable: { number: number, abbreviation: string, name: string }[] = [
  {
    number: 1e6,
    abbreviation: 'M',
    name: 'Million',
  },
  {
    number: 1e9,
    abbreviation: 'B',
    name: 'Billion',
  },
  {
    number: 1e12,
    abbreviation: 'T',
    name: 'Trillion',
  },
  {
    number: 1e15,
    abbreviation: 'Qa',
    name: 'Quadrillion',
  },
  {
    number: 1e18,
    abbreviation: 'Qi',
    name: 'Quintillion',
  },
  {
    number: 1e21,
    abbreviation: 'Sx',
    name: 'Sextillion',
  },
  // {
  //   number: 1e24,
  //   abbreviation: 'Sp',
  //   name: 'Septillion',
  // },
  // {
  //   number: 1e27,
  //   abbreviation: 'Oc',
  //   name: 'Octillion',
  // },
]
</script>
<template>
  <TheBottomSheet
    :show="show"
    centered
    @hide="$emit('hide')"
  >
    <div class="w-full flex flex-col gap-y-6 items-center">
      <CoinIcon class="h-[100px] w-auto" />
      <div class="flex flex-col items-center text-center gap-y-3">
        <h2 class="text-2xl font-bold text-light-white -tracking-[0.48px]">
          <T
            key-name="number_formatting.modal.title"
            default-value="Big numbers, big rewards!"
          />
        </h2>
        <p class="text-lg font-semibold text-white/[87%]">
          <T
            key-name="number_formatting.modal.title"
            default-value="Boost your trading per hour and climb to the top. Here’s your quick guide to mastering coin values:"
          />
        </p>
      </div>
      <div class="flex flex-col w-full gap-y-2">
        <div class="w-full flex items-center justify-between text-sm font-bold text-white/60">
          <span>
            <T
              key-name="number_formatting.modal.abbreviation"
              default-value="Abbreviation"
            />
          </span>
          <span>
            <T
              key-name="number_formatting.modal.number"
              default-value="Number"
            />
          </span>
        </div>
        <div
          v-for="(formatting, index) in formattingTable"
          :key="index"
          class="w-full flex justify-between items-center text-xs font-semibold gap-x-2"
        >
          <div class="flex items-center justify-between gap-x-2 w-[93px]">
            <span class="w-full flex-1">  {{ formatting.abbreviation }}</span>
            <span class="w-full text-center"> {{ formatting.name }}</span>
          </div>
          <span class="w-max">
            {{ numberToStringFormat(formatting.number) }}  </span>
        </div>
      </div>
      <!--      <BaseButton-->
      <!--        class="w-full"-->
      <!--        style-type="tertiary"-->
      <!--      >-->
      <!--        <T-->
      <!--          key-name="number_formatting.modal.cta"-->
      <!--          default-value="Got it"-->
      <!--        />-->
      <!--      </BaseButton>-->
    </div>
  </TheBottomSheet>
</template>